import Alpine from "alpinejs";
import mask from "@alpinejs/mask";
import Swiper from 'swiper/bundle'

// RKT components
import mediaPlayer from "./components/plyr";
import parallax from './components/parallax'
import aos from './components/aos'
import recentlyViewed from "./components/recently-viewed";
import map from "./components/map";

// Alpine components
import addToCart from "./alpine/addtocart.js";
import miniCart from "./alpine/minicart.js";
import product from "./alpine/product.js";
import { store, origin } from "./store.js";

window.Alpine = Alpine
Alpine.store("shopify", store);
Alpine.data("addtocart", addToCart);
Alpine.data("minicart", miniCart);
Alpine.data("product", product);
Alpine.plugin(mask);

// Axios (if needed)
let axios = require("axios");
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

console.log("Current Theme: ", Shopify.theme.name);

// All other on page component init stuff:
mediaPlayer() // init
parallax() // init
aos() // init
recentlyViewed() // init
map() // init

Alpine.start();

// Stupid ugly hack for dumb Safari because it tries to load from cache
window.onpageshow = function (event) {
	if (event.persisted) {
		window.location.reload();
	}
};

// init any Swiper elements.
const recipesSwiper = new Swiper(".recipes-slider", {
	breakpoints: {
		0: {
			slidesPerView: 1,
			spaceBetween: 20,
		},
		640: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 5,
			spaceBetween: 20,
		},
	},
	slidesPerView: 5,
	spaceBetween: 30,
	centerInsufficientSlides: true,
	pagination: {
		el: ".swiper-pagination",
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});
// const brandsSwiper = new Swiper('.ourbrands-slider', {
// 	// breakpoints: {
// 	// 	0: {
// 	// 		slidesPerView: 1,
// 	// 		spaceBetween: 20
// 	// 	},
// 	// 	1024: {
// 	// 		slidesPerView: 3,
// 	// 		spaceBetween: 20
// 	// 	},
// 	// 	1280: {
// 	// 		slidesPerView: 5,
// 	// 		spaceBetween: 20
// 	// 	},
// 	// },
// 	effect: "cards",
// 	grabCursor: true,
// });
